import { getCurrentPackageName } from 'quartz/framework/environment/service';

// Local storage key for whether Copilot was previously open when the page loaded (i.e. open after a page reload)
// Values can be one of the following integers: 0 | 1 | 2
// 0 = closed | 1 = open | 2 = open expanded view
export const COPILOT_INITIALIZE_OPEN = 'copilot-initialize-open';

// https://github.com/HubSpotEngineering/breeze-assistant-issues/issues/3754
// Gate result is persisted to localStorage (per-app) after auth. On the next
// page load, configureNavLoader reads it to decide whether to auto-open the
// panel. configureNavLoader is the sole trigger — it runs synchronously in the
// HTML head before anything else reads sessionStorage, avoiding race conditions
// with async React renders.
export const COPILOT_AUTO_OPEN = 'copilot-auto-open';

// Possible values for the COPILOT_AUTO_OPEN-{app} localStorage key:
//   'true'        — gate is on, panel not yet triggered today
//   'YYYY-MM-DD'  — date the panel last auto-opened (throttles to once per day)
//   absent/null   — gate is off, or key was never written

export function getAutoOpenAppKey() {
  try {
    return getCurrentPackageName();
  } catch (_unused) {
    return '';
  }
}
export function getIsCopilotDisabled(navLoaderOptions) {
  var _hubspot;
  if (navLoaderOptions === false) {
    return true;
  }
  // configureNavLoader runs in the page head and resolves the embedded-defer
  // decision into window.hubspot.copilot.disableCopilotWhenEmbedded; read that
  // resolved value rather than re-deriving it here.
  return Boolean((_hubspot = window.hubspot) === null || _hubspot === void 0 || (_hubspot = _hubspot.copilot) === null || _hubspot === void 0 ? void 0 : _hubspot.disableCopilotWhenEmbedded);
}
export const COPILOT_SIDEBAR_SIDE = 'copilot-sidebar-side';
export const getShouldStartWithCopilotOpen = () => {
  try {
    const isCopilotInitiallyOpen = sessionStorage.getItem(COPILOT_INITIALIZE_OPEN);
    return isCopilotInitiallyOpen === '1' || isCopilotInitiallyOpen === '2';
  } catch (e) {
    return false;
  }
};